import Localizer from 'localizer';
import ActivitiesUtil from 'utils/activity/ActivitiesUtil';
import { DYNAMIC_APNEA_DIVE, DYNAMIC_APNEA_STA, DYNAMIC_APNEA_REST } from 'constants/TypedSplitsConstants';

var maxHoursOfBottomTime = 999;

export default {
    maxHoursOfBottomTime: maxHoursOfBottomTime,
    maxSecondsOfBottomTime: maxHoursOfBottomTime * 60 * 60,
    apneaActivityListMetrics: [
        'maxDepth',
        'bottomTime',
        'numberOfApneaDives',
        'totalSurfaceTime',
        'summarizedDiveInfo.waterType'
    ],
    defaultGasTank: {
        gasIndex: 0,
        heliumContent: 0,
        oxygenContent: 21,
        tankEndingPressure: null,
        tankEndingPressureUnit: null,
        tankSize: null,
        tankSizeUnit: null,
        tankStartingPressure: null,
        tankStartingPressureUnit: null,
        tankType: null,
        status: 1
    },

    formatNumberOfDives: function(numDives) {
        if (numDives === null) {
            return '';
        } else if (numDives < 2) {
            return numDives + ' ' + Localizer.localize('label_num_dives_singular');
        } else {
            return numDives + ' ' + Localizer.localize('label_num_dives');
        }
    },

    hasApneaDives: function(activityTypeKey, isManualActivity, activitySplits) {
        if (ActivitiesUtil.isApneaDiving(activityTypeKey)) {
            if (activitySplits && activitySplits.get('lapDTOs').length > 0 && !isManualActivity) {
                return true;
            }
        }
    },

    maxPoolApneaDistance: 999.9,
    poolApneaIntervalTypes: [DYNAMIC_APNEA_DIVE, DYNAMIC_APNEA_STA, DYNAMIC_APNEA_REST],
    poolApneaDisciplineTypesDYN: [
        'DYNAMIC_WITH_FINS',
        'DYNAMIC_WITHOUT_FINS',
        'DYNAMIC_WITH_BIFINS',
        'SPEED_ENDURANCE_APNEA'
    ],

    buildPoolApneaIntervalsTableRows: function(typedSplits) {
        return typedSplits?.filter((split) => this.poolApneaIntervalTypes.includes(split.type));
    }
};
